export const marketingEn = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Free Quickstart',
  'marketing.free.seo.description':
    'Get the free Grymwyrd Quickstart — the rules and a one-shot you can run tonight. Enter the Twilight.',
  'marketing.free.eyebrow': 'Your free passage',
  'marketing.free.heading': 'Enter the Twilight — free',
  'marketing.free.subheadLead': 'The',
  'marketing.free.quickstartName': 'Grymwyrd Quickstart',
  'marketing.free.subheadTail':
    '— core rules plus a one-shot adventure you can run tonight. Tell us where to send it.',
  'marketing.free.benefit.rules.title': 'The rules',
  'marketing.free.benefit.rules.body': 'Everything you need to play, distilled into a quickstart.',
  'marketing.free.benefit.oneShot.title': 'A one-shot',
  'marketing.free.benefit.oneShot.body': 'A ready-to-run horror adventure for your first night.',
  'marketing.free.benefit.livingWorld.title': 'Living world',
  'marketing.free.benefit.livingWorld.body': 'Hooks into an encyclopedia, maps, and weekly drops.',
  'marketing.free.playInstead.heading': 'Rather just play?',
  'marketing.free.playInstead.body':
    'Forge your first character and run a 10-minute solo trial — no purchase, no commitment.',
  'marketing.free.playInstead.cta': 'Forge a character',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Something went wrong. Try again shortly.',
  'marketing.leadForm.ready': 'Your free Quickstart is ready.',
  'marketing.leadForm.downloadCta': 'Download your Quickstart',
  'marketing.leadForm.alsoEmailed': "We've also sent the link to your inbox.",
  'marketing.leadForm.checkInbox': 'Check your inbox — your free Quickstart is on its way.',
  // Shown when the world has no Quickstart PDF yet: the lead is stored, nothing to download.
  'marketing.leadForm.pending': "You're on the list. We'll email you the Quickstart the day it's ready.",
  'marketing.leadForm.emailPlaceholder': 'you@example.com',
  'marketing.leadForm.emailAriaLabel': 'Email address',
  'marketing.leadForm.defaultCta': 'Send me the Quickstart',
  'marketing.leadForm.privacyNote':
    'No spam — just the Quickstart and the occasional lore drop. Unsubscribe anytime.',
} as const
